import SearchIcon from '../icons/SearchIcon';

export default function SearchButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      id="ostro-webchat-search-button"
      className="rounded-full h-[44px] w-[44px] text-center flex items-center justify-center"
      onClick={onClick}
      aria-label="Search"
      tabIndex={0}
    >
      <SearchIcon className="color-black w-4" />
    </button>
  );
}
